import React, { useEffect, useState } from 'react'
import { CancelButton, ClearFilterButton, CreateButton, ExportButton, FilterButton, ImportButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { NuDate } from '../../../../Components/Utils/Input';
import CloseIcon from '../../../../Components/Icons/Close';
import CreateEmailSent from './CreateEmailSent';
import ImportEmail from './ImportEmail';
import MultiEditEmail from './MultiEditEmail';
import CustomDataTable from '../../../../Components/Others/CustomDataTable';
import { GetAccess } from '../../../../Components/Utils/roles';
import EmailLayout from '../EmailLayout';
import axiosInstance from '../../../../Services/axiosCommon';
import { useFormik } from 'formik';
import UseGetDataSearchByProUser from '../../../../Components/Hooks/useFetchDataByPROUser';
import { Link, useLocation } from 'react-router-dom';
import { useToast } from '../../../../Components/Others/ToastServices';
import * as yup from 'yup';
import EmailMobileIndex from '../../../Mobile/Email/EmailMobileIndex';
import SearchBar from '../../../../Components/Utils/SearchBar';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';





function EmailSentIndex() {
const [showFilterDialog, setShowFilterDialog] = useState(false);

  const { value: Status, getData: refStatus } = useFetchMDIndex(
                                 `/dropdown/dropdown-details/`,
                                 "Status",showFilterDialog)

  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
const toast = useToast();
const location = useLocation();
 const currentPage= location.state?.currentPage
const searchQuery= location.state?.searchQuery
const [page, setPage] = useState(currentPage||1)
const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
const [filter, setFilter] = useState(false);
 const [createModalOpen, setCreateModalOpen] = useState(false); // State to handle modal open/close
const [projectList, setProjectList] = useState([]);
// const [isEditModalOpen, setIsEditModalOpen] = useState(false); // Edit modal state
const [open, setOpen] = useState(false);

const [filterProps, setFilterProps] = useState({
  category:"",
  subCategory:"",
  brand:"",
  manufacturer:"",
  underPromotion:"",
  unit:""
});
const [params, setParams] = useState({
  page: page,
  per_page: pageCount,
  search:searchQuery||"",
  category:"",
  subCategory:"",
  brand:"",
  manufacturer:"",
  underPromotion:"",
  unit:""
});
const clearFilter = ()=> {
  setParams({...params, category:"",
  subCategory:"",
  brand:"",
  manufacturer:"",
  underPromotion:"",
  unit:""
})
formik.values.category=""
formik.values.subCategory=""
formik.values.brand=""
formik.values.manufacturer=""
formik.values.underPromotion=""
formik.values.unit=""


    setFilter(false)
}

const formik = useFormik({
  enableReinitialize: true,
  initialValues: filterProps,
  validateOnChange: false,
  validateOnBlur: false,
  validationSchema: yup.object({
    // email: yup.string().required('Email is required!'),
  }),
  onSubmit: async (value, { resetForm }) => {
    console.log("ffff",value);
    setParams({...params,category:value.category, subCategory:value.subCategory,brand:value.brand,manufacturer:value.manufacturer,underPromotion:value.underPromotion,unit:value.unit})
    closeFilterDialog();
    setFilter(true)
    setFilterProps({
      category:"",
      subCategory:"",
      brand:"",
      manufacturer:"",
      underPromotion:"",
      unit:""
    });
  }
})


const { data, totalCount, getData,dataLoading } = UseGetDataSearch( `/email/all-emails`,params);
const defaultHeader = [
  // {
  //   title: "ID",
  //   width: "5%",
    
  //   field: "emailId",
  //   textAlign: "left",
  //   rowAlign: "left",
  // },
  {
    title: "Date",
    width: "10%",
     type:'date',
    field: "date",
    textAlign: "left",
    rowAlign: "left",
  },
  {
    title: "To",
    width: "25%",     
    field: "toMails",
    textAlign: "left",
    rowAlign: "left",
  },
  // {
  //   title: "CC",    
  //   width: "15%",
  //   field: "cc",
  //   textAlign: "left",
  //   rowAlign: "left",
  // },
  {
    title: "Subject",    
    width: "25%",
    field: "subject",
    textAlign: "left",
    rowAlign: "left",
  },

  {
    title: "Status",    
    width: "10%",
    field: "status",
    textAlign: "left",
    rowAlign: "left",
  },
 
  {
    title: "Action",
    width: "6%",
    field: "action",
    textAlign: "center",
    rowAlign: "center",
   
      contents:{
        // fetcher:getData,
        id:"emailId",
        removeValue:"to",
        url:`/email/`,
        moduleName:"Email",
        from:`/email/email-sent`,
        // editLink:`/email/email-sent/edit/`,
        viewLink:`/email/email-sent/view/`
      }    
    },
  
];
const availableHeaders = [
  
  
];
const [showExport, setShowExport] = useState(false);
const [exportValue, setExportValue] = useState({
  Client:"",
  Project:"",
  salesPerson:"",
  Location:"",
  Inspector:"",
  InspectionDate:"",
  Status:"",
});
const ExportFormik = useFormik({
  enableReinitialize: true,
  initialValues: exportValue,
  validateOnChange: false,
  validateOnBlur: false,
  onSubmit: async (value, { resetForm }) => {
    try {
      const response = await axiosInstance.get(
        `/customer-quotations/export-to-excel?approvalStatus=${value.approvalStatus}&salesPerson=${value.salesPerson}&status=${value.status}&leadTime=${value.leadTime}&validity=${value.validity}&availability=${value.availability}&paymentMethod=${value.paymentMethod}&paymentTerms=${value.paymentTerms}&deliveryTerms=${value.deliveryTerms}&fromDate=${value.fromDate}&toDate=${value.toDate}`,
        {
          responseType: "blob",
        }
      );

      const pdfBlob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(pdfBlob);
      link.download = `CQ Report ${NuDate({
        value: new Date(),
        format: "DD-MMM-YYYY",
      })}.xlsx`;

      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  },
});
const closeFilterDialogebox = () => {
  setShowExport(false);
};

useEffect(()=>{
  setParams({...params,page:page,per_page:pageCount})
 },[page,pageCount])

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
    const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };


  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [listofNumbers, setListofNumbers] = useState([])
  const [fullList, setFullList] = useState([])

  const selectOneFunction = (value) =>{ 
    let NewId;
    if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
      NewId = listofNumbers.filter(Temp=> Temp !== value);
      setListofNumbers(NewId)
    }else{
      setListofNumbers([...listofNumbers,value])
    }
  }

  const selectMultipleFunction = (e) =>{ 
console.log(e.target.checked);
if(e.target.checked){
  setListofNumbers(fullList)
}else{
  setListofNumbers([])
}

  }
 
  useEffect(()=>{
    let tempArr = []
    data && data.forEach(i=>{
     
      tempArr.push(i?.id)
    });
    setFullList(tempArr)
  },[data])

  const [valueOfSearch,setValuesofSearch] = useState("")
   function searchFunction(e) {  
     
     setValuesofSearch(e?.target?.value)
     setParams({ ...params, search: e?.target?.value, page:1 });
     setPage(1)
   }

 
  
 

  
return (
   <>
   <EmailLayout 
  setOpen={setShowImportModal}
  searchFun={searchFunction}
  setOpenExport={setShowExport}

    getData={getData}
    isCard={true}
    isFilter={filter}
     newfilter={true}
    setFilterOpen={setShowFilterDialog}
    ClearFilter={clearFilter}
    CreateAccess={GetAccess("customers_create")}
    ImportAccess={GetAccess("customers_create")}
    ExportAccess={GetAccess("email_export")}
    onCreateClick={() => setCreateModalOpen(true)} 

        searchValue={valueOfSearch}
      neededSearch={true}
            total={totalCount}

       >
          {/* <div className='w-full flex justify-between items-center'>
      <Breadcrumb
         items={[
          {
            name: "Email",

          },
        

          ]} />
        <div className=' flex gap-2'>
        <SearchBar
              handleChange={(e) =>{
                setParams({ ...params, search: e.target.value, page:1 });
                setPage(1)
              }}
              value={params.search||searchQuery}
            />
          
          <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
          {filter && <ClearFilterButton  handleClick={()=>clearFilter()} label='Clear'/>}
        
            <ImportButton handleClick={handleImportClick} />
            <ExportButton handleClick={() => setShowExport(true)}/>

        </div>
      </div> */}
      {
screenSize.width <= "786" ?(<>
<div className=' w-full h-[calc(100vh-205px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
<EmailMobileIndex
data={data}
total={totalCount}
pageIndex={page}
setPageIndex={setPage}
dataCount={pageCount}
setDataCount={setPageCount}
getData={getData}
/>
</div>
</>):(<>
  <div className='w-full h-full '>

    <CustomDataTable 
    fetcher={getData}
      data={data} 
      availableHeaders={availableHeaders} 
      defaultHeader={defaultHeader}
      bodyHeight='max-h-[calc(100vh-260px)] '
      height='h-[calc(100vh-145px)]'
      total={totalCount}
      pageIndex={page}
      setPageIndex={setPage}
      dataCount={pageCount}
      setDataCount={setPageCount}
      title='Email' 
      storageName="EmailTable"
      selectOneFunction={selectOneFunction}
      setShowDelete={setShowDelete}
      showDelete={showDelete}
      setShowEdit={setShowEdit}
      showEdit={showEdit}
      listofNumbers={listofNumbers}
      // hasMultiEdit={true}
      selectMultipleFunction={selectMultipleFunction}
      fullList={fullList}
      getById="emailId"
      showFieldFalse={false}
      // editAccess="items_edit"      
      deteleAccess="email_delete"
      dataLoading={dataLoading}   
      searchQuery={params?.search!=""?params?.search:""}
      />
  </div>
  </>)
}
         
         {showEdit && (
    <MultiEditEmail
      data={listofNumbers}
      getData={getData}
      onClose={() => setShowEdit(false)}
    />
  )}
  {showImportModal && (
    <ImportEmail
      show={showImportModal}
      onClose={closeModal}
      getData={getData}
    />
  )}
       <CreateEmailSent
        open={createModalOpen}
        onCancel={() => {
          setCreateModalOpen(false);
        }}
        projectList={projectList || []}
        getData={getData}
        // firstProject={firstProject}
      />
        {showFilterDialog && (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
      <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
        <h2 className="text-xl mb-4">Filter </h2>
        <form onSubmit={formik.handleSubmit}>
          <div className="flex flex-col mb-4">
         
            <FormikSelectTwo
                          label="Status"
                         Options={Status}
                         formik={formik}
                         placeholder="Choose"
                         name="status"
                       
           
                         width="w-full"
                         displayProperty={"Status"}
                         propertyName={"Status"}
                            getFunc={refStatus}
           
                       />
          </div>
          <div className="flex justify-end gap-2">
            <CancelButton handleClick={closeFilterDialog} />
            <SubmitButton name="Apply" />
          </div>
        </form>
      </div>
    </div>
  )}
       {showExport && (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
      <div className="animate-scale-in min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
        <div className=" w-full flex justify-between items-center  bg-white">
          <h2 className=" text-sm 2xl:text-base font-medium ">
            Export Data
          </h2>
          <div
            className=" cursor-pointer "
            onClick={() => setShowExport(false)}
          >
            <CloseIcon />
          </div>
        </div>
        <form onSubmit={ExportFormik.handleSubmit}>
          <div className=" w-full flex flex-wrap">
            <div className=" w-full flex ">
              <div className=" w-1/2 flex items-center px-6 py-3 ">
                <input
                  id="default-radio-1"
                  type="radio"
                  value="all"
                  name="type"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                  onChange={ExportFormik.handleChange}
                  checked={ExportFormik.values.type =="all"}
                />
                <label
                  htmlFor="default-radio-1"
                  className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                >
                  All Data
                </label>
              </div>

              <div className="w-1/2 flex items-center px-6 py-3">
                <input
                  id="default-radio-2"
                  type="radio"
                  value="filter"
                  name="type"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                  onChange={ExportFormik.handleChange}
                  checked={ExportFormik.values.type == "filter"}
                />
                <label
                  htmlFor="default-radio-2"
                  className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                >
                  Filter Data
                </label>
              </div>
            </div>
            {ExportFormik.values.type === "filter" && (
              <>
                <NuDate
                  label="From "
                  placeholder="dd/mm/yyyy"
                  formik={ExportFormik}
                  name="fromDate"
                  width="w-1/2 "
                />
                <NuDate
                  label="To "
                  placeholder="dd/mm/yyyy"
                  formik={ExportFormik}
                  name="toDate"
                  width="w-1/2"
                />

                <FormikSelectTwo
                  type="text"
                  label="Sales Person"
                  placeholder="Choose"
                  Options={[]}
                  formik={ExportFormik}
                  name="salesPerson"
                  width="w-1/2"
                />

              </>
            )}
            <div className="flex w-full justify-end gap-2">
              <CancelButton handleClick={closeFilterDialogebox} />
              <SubmitButton name="Export" />
            </div>
          </div>
        </form>
      </div>
    </div>
  )}
    
     </EmailLayout>
  </>
)
}



export default EmailSentIndex
